import ls from 'localstorage-slim';

import { FeatureFlagsType } from '../featureFlags';

export const OVERRIDES_STORAGE_KEY = '__DATABASES_FF_OVERRIDES';

const flagsStorageInstance = ls;

/**
 * Determine whether there are any persisted FF overrides
 */
export const hasOverrides = (): boolean =>
  flagsStorageInstance.get(OVERRIDES_STORAGE_KEY) !== null;

/**
 * Get persisted overrides from the storage.
 */
export const getOverrides = (): FeatureFlagsType => {
  if (!hasOverrides()) {
    return {};
  }

  return flagsStorageInstance.get(OVERRIDES_STORAGE_KEY) ?? {};
};

export const addOverrides = (newOverrides: FeatureFlagsType): void => {
  const overrides = getOverrides();
  for (const flagKey in newOverrides) {
    overrides[flagKey] = newOverrides[flagKey];
  }

  flagsStorageInstance.set(OVERRIDES_STORAGE_KEY, overrides);
};

export const removeOverrides = (overridesToRemove: string[]): void => {
  const overrides = getOverrides();
  for (const flagKey in overridesToRemove) {
    delete overrides[overridesToRemove[flagKey]];
  }

  flagsStorageInstance.set(OVERRIDES_STORAGE_KEY, overrides);
};

export const clearOverrides = (): void => {
  flagsStorageInstance.remove(OVERRIDES_STORAGE_KEY);
};

/**
 * It returns an object with ALL feature flags.
 */
export const applyPersistedOverrides = (
  featureFlags: FeatureFlagsType
): FeatureFlagsType => {
  const overrides = getOverrides();
  return Object.keys(featureFlags).reduce((acc: FeatureFlagsType, key) => {
    acc[key] = key in overrides ? overrides[key] : featureFlags[key];

    return acc;
  }, {});
};
